import styles from './Slider.module.css'

interface SliderProps {
  label: string
  value: number
  min: number
  max: number
  step: number
  onChange: (value: number) => void
  /** Подписи концов шкалы: объясняют, в какую сторону крутить. */
  ends?: [string, string]
  hint?: string
  /**
   * Подпись не показывать: она уже есть слева, в строке настройки.
   * Атрибут доступности при этом остаётся — диктору подпись нужна.
   */
  hideLabel?: boolean
  /** Как показать значение. По умолчанию — как есть. */
  format?: (value: number) => string
}

export function Slider({
  label,
  value,
  min,
  max,
  step,
  onChange,
  ends,
  hint,
  hideLabel = false,
  format,
}: SliderProps) {
  return (
    <div className={styles.field}>
      <div className={styles.head}>
        {!hideLabel && <label className={styles.label}>{label}</label>}
        <span className={styles.value}>{format ? format(value) : value}</span>
      </div>

      <input
        className={styles.input}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label={label}
      />

      {ends && (
        <div className={styles.ends}>
          <span>{ends[0]}</span>
          <span>{ends[1]}</span>
        </div>
      )}

      {hint && <span className={styles.hint}>{hint}</span>}
    </div>
  )
}
